<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
       <span slot="left">
        <a-button type="primary" class="button-color-green" @click="handleCreate">新增</a-button>
       </span>
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleUpdate(record)">更新</a>
        <a-divider type="vertical" />
        <a @click="channelFn(record)">渠道能力</a>
       </span>
    </BTable>
    <UpdateChannel
      ref="editorRef"
      :item="modifyItem"
      title="更新渠道"
      :channel-list="channelList"
      @success="() => { this.$refs.table.refresh() }"
    >
    </UpdateChannel>
    <ChannelAbility
      ref="channelAbility"
      title="渠道能力"
      width="800px"
      :channel-id="channelId"
      @success="() => { this.$refs.table.refresh() }"
    >
    </ChannelAbility>
    <AddChannel
      ref="addRef"
      title="渠道新增"
      @success="() => { this.$refs.table.refresh(true) }"
    >
    </AddChannel>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Attributes',
  components: {
    UpdateChannel: () => import('./components/UpdateChannel'),
    ChannelAbility: () => import('./components/ChannelAbility.vue'),
    AddChannel: () => import('./components/AddChannel')
  },
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam
        }
        return this.$http.channel.channelQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '渠道名称',
          key: 'channelNo',
          type: 'select',
          options: [],
          optionKey: 'channelNo',
          optionValue: 'channelName'
        },
        {
          label: '状态',
          key: 'status',
          type: 'select',
          options: this.$u.getSelectOptionsByDataMap('channelStatus', this.dataMap),
          // keyValue: true,
          optionKey: 'key',
          optionValue: 'value'
        }
      ],
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '渠道号',
          dataIndex: 'channelNo' // no
        },
        {
          title: '渠道名称',
          dataIndex: 'channelName'
        },
        {
          title: '渠道类型',
          dataIndex: 'channelTypeDesc'
        },
        {
          title: '渠道实体',
          dataIndex: 'channelEntity'
        },
        {
          title: '渠道状态',
          dataIndex: 'status',
          customRender: (currencyStatus, record, index) => {
            // const { currencyStatus } = record // 01 启 02关
            const checked = currencyStatus === '01'
            return (
              <a-switch
                key={record.id}
                checked-children="启用" un-checked-children="禁用"
                loading={this.changeLoading}
                defaultChecked={checked}
                onChange={value => { this.handleChange(record, value) }}></a-switch>
            )
          }
        },
        {
          title: '创建人',
          dataIndex: 'createUserName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '更新人',
          dataIndex: 'updateUserName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]),
      changeLoading: false,
      modifyItem: {},
      channelList: [],
      channelId: NaN
    }
  },
  async created () {
    await this.getQueryParams()
  },
  methods: {
    async handleChange (record, value) {
      this.changeLoading = true
      const { succ } = await this.$http.channel.channelUpdate({ status: value ? '01' : '02', id: record.id })
      this.changeLoading = false
      if (succ) {
        this.$message.destroy()
        this.$message.success('状态修改成功!')
        this.$refs.table.refresh()
      }
    },
    async getQueryParams () {
      const { data } = await this.$http.channel.channelQueryList({ request: {} })
      const channelSelect = this.searchList[0]
      this.channelList = data
      this.$set(this.searchList, 0, Object.assign({}, channelSelect, { options: data }))
    },
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    },
    handleUpdate (item) {
      this.modifyItem = item
      this.$refs.editorRef.visible = true
    },
    channelFn (item) {
      const { id } = item
      this.channelId = id
      this.$refs.channelAbility.visible = true
    },
    handleCreate () {
      this.$refs.addRef.visible = true
    }
  }
}
</script>

<style scoped lang="less">
</style>
